import React, { useMemo, useState } from "react";
import logo_only from "../../assets/logos/logo_only.png";
import logo_white from "../../assets/logos/logo_white.png";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { Popover } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { GoHome } from "react-icons/go";
import { IoIosNotificationsOutline, IoMdLogOut } from "react-icons/io";
import { getUpdateRequest } from "../../Redux/thunks/getUpdateRequest";
import { useScrollPosition } from "../../Components/useScrollPosition";
import Dropdown from "../Dropdown/dropdown";
import { motion, AnimatePresence } from "framer-motion";
import { RESET_ALL_STATES } from "../../Redux/actions/actions";
import { persistor } from "../../Redux/store";
import Notification from "./Notification";
import { t } from "i18next";
import apiClient from "../../utils/apiClient";
import esignetClient from "../../auth/esignet";
 
const NavBar = () => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(
        (state) => state.session.isAuthenticated,
    );
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const scrollPosition = useScrollPosition();
    const [handleFetchClickTriggered, setHandleFetchClickTriggered] =
        useState(false);
    const [renderSection, setRenderSection] = useState(null);
    const uniqueIdObject = useSelector((state) => state.uin);
    const uniqueId = uniqueIdObject.uin;
    const [currentLang, setCurrentLang] = useState(i18n.language);
    const { isLoading, error, data } = useSelector(
        (state) => state.residentlog,
    );
    const arrayOfData =
        isAuthenticated && handleFetchClickTriggered ? data?.data : "";

    const handleFetchClick = async () => {
        try {
            const response = await apiClient.get(`/updateRequest/${uniqueId}`);
            setHandleFetchClickTriggered(true);
            setRenderSection("data");
        } catch (error) {
            console.error("Error fetching update request:", error);
            setRenderSection("error");
        }
    };
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };
    const location = useLocation();
    const path = location.pathname.split("/")[1];

    const checkPath = (path) => {
        const allRouteTitles = [
            { title: "correctdemo", value: "Correct Demographic" },
        ];
        return allRouteTitles[path]?.value;
    };

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const logoutUser = () => {
        dispatch({ type: "LOGOUT" });
        dispatch({ type: RESET_ALL_STATES });
        persistor.purge();
        navigate("/");
    };

    return (
        <div
            className={`md:fixed md:top-0 w-full flex justify-between lg:px-32 z-40 text-white py-4 items-center px-5 ${
                path === "" ? "" : "bg-MetallicBlue"
            } ${scrollPosition > 0 ? "bg-MetallicBlue" : ""}`}
        >
            <div className='flex h-12 md:h-16'>
                <img
                    src={isMobile ? logo_only : logo_white}
                    className='object-cover'
                    alt='fayda logo'
                />
            </div>
            {path === "" ? null : <div>{checkPath(path)}</div>}
            <div className='md:flex md:gap-5 gap-5 flex items-center'>
                {isAuthenticated && (
                    <>
                        <Dropdown
                            button={
                                <p
                                    className='cursor-pointer h-fit text-white hover:text-niblue  bg-white rounded-full overflow-clip p-2'
                                    onClick={handleFetchClick}
                                >
                                    <IoIosNotificationsOutline className='duration-300 bg-white text-MetallicBlue ' />
                                </p>
                            }
                            animation='origin-[27%_0%] md:origin-[22%_0%] sm:origin-[34%_0%] transition-all duration-500 ease-in-out'
                            classNames={
                                "flex max-w-[440px] py-0.5 px-0.5 top-10 md:top-10 md:-left-[80px] sm:-left-[110px] -left-[80px] rounded-lg"
                            }
                            children={<Notification />}
                        />
                        <div
                            className='cursor-pointer h-fit text-white hover:text-niblue  bg-white rounded-full overflow-clip p-2'
                            title='Dashboard'
                            onClick={() => {
                                navigate("/dashboard");
                            }}
                        >
                            <GoHome className='duration-300 bg-white text-MetallicBlue ' />
                        </div>
                    </>
                )}

                <a
                    href='https://id.et/faq'
                    className='md:border-2 md:border-white rounded-full items-center md:px-10 px-3 md:italic bg-white text-nidblue hover:cursor-pointer'
                >
                    <div>
                        <span className='hidden md:block'>{t("help")}</span>
                        <span className='block md:hidden font-bold text-2xl'>
                            ?
                        </span>
                    </div>
                </a>

                <Popover
                    className='hidden md:block'
                    overlayInnerStyle={{ color: "#000" }}
                    content={
                        <div className='flex flex-col gap-2 w-[100px]'>
                            <button
                                className='w-full bg-MetallicBlue text-white text-md rounded-md py-1'
                                onClick={() => changeLanguage("en")}
                            >
                                English
                            </button>
                            <button
                                className='w-full bg-MetallicBlue text-white text-md rounded-md py-1'
                                onClick={() => changeLanguage("amh")}
                            >
                                አማርኛ
                            </button>
                            <button
                                className='w-full bg-MetallicBlue text-white text-md rounded-md py-1'
                                onClick={() => changeLanguage("so")}
                            >
                                AF Soomaali
                            </button>
                        </div>
                    }
                    open={open}
                    onOpenChange={handleOpenChange}
                >
                    <button className='border-2 border-white rounded-full px-10 italic py-0.5'>
                        {i18n.language === "amh" ? "English" : "አማርኛ"}
                    </button>
                </Popover>

                <div
                    className='block md:hidden cursor-pointer text-nidblue hover:text-niblue hover:bg-slate-500 rounded-full hover:scale-95 duration-100 transition- hover:ring-white ring-0.5 hover:text-white bg-white'
                    title='Language'
                    onClick={() => {
                        const newLang = currentLang === "en" ? "amh" : "en";
                        i18n.changeLanguage(newLang);
                        setCurrentLang(newLang);
                        localStorage.setItem(
                            "LanguageState",
                            JSON.stringify(newLang),
                        );
                    }}
                >
                    <button className='w-8 h-8 flex items-center justify-center text-2xl font-bold relative overflow-hidden'>
                        <AnimatePresence mode='wait'>
                            {currentLang === "en" ? (
                                <motion.span
                                    key='en'
                                    initial={{
                                        y: 20,
                                        opacity: 0,
                                    }}
                                    animate={{
                                        y: 0,
                                        opacity: 1,
                                    }}
                                    exit={{
                                        y: -20,
                                        opacity: 0,
                                    }}
                                    transition={{
                                        duration: 0.2,
                                    }}
                                    className='absolute'
                                >
                                    E
                                </motion.span>
                            ) : (
                                <motion.span
                                    key='amh'
                                    initial={{
                                        y: 20,
                                        opacity: 0,
                                    }}
                                    animate={{
                                        y: 0,
                                        opacity: 1,
                                    }}
                                    exit={{
                                        y: -20,
                                        opacity: 0,
                                    }}
                                    transition={{
                                        duration: 0.2,
                                    }}
                                    className='absolute'
                                >
                                    አ
                                </motion.span>
                            )}
                        </AnimatePresence>
                    </button>
                </div>

                {isAuthenticated && (
                    <button
                        className='flex md:hidden items-center gap-1 py-2 hover:bg-MetallicBlue/80'
                        onClick={logoutUser}
                    >
                        <IoMdLogOut size={36} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default NavBar;
